const navigateToKey = 'session_navigateTo';
const fiscalYearKey = 'session_fYDetails';
const shIdKey = 'session_paramId';
const roleKey = 'session_role';

const SessionService = {

  setNavigateTo: (to: any) => {
    const serializedHeader = JSON.stringify(to);
    localStorage.setItem(navigateToKey, serializedHeader);    
  },

  getNavigateTo: () => {
    const serializedHeader = localStorage.getItem(navigateToKey);
    return serializedHeader ? JSON.parse(serializedHeader) : null;    
  },
 
  setFiscalYearDetails: (data: any) => {
    const serializedHeader = JSON.stringify(data);
    localStorage.setItem(fiscalYearKey, serializedHeader);    
  },

  getFiscalYearDetails: () => {
    const serializedHeader = localStorage.getItem(fiscalYearKey);
    return serializedHeader ? JSON.parse(serializedHeader) : null;    
  },

  setSHId: (id: string) => {
    localStorage.setItem(shIdKey, JSON.stringify(id));    
  },

  getSHId: () => {
    const serializedHeader = localStorage.getItem(shIdKey);
    return serializedHeader ? JSON.parse(serializedHeader) : null;
  },
  
  setRole: (role: any) => {
    localStorage.setItem(roleKey, JSON.stringify(role));    
  },

  getRole: () => {
    const serializedHeader = localStorage.getItem(roleKey);
    return serializedHeader ? JSON.parse(serializedHeader) : null;
  },

  clearSHId: () => {
    localStorage.removeItem(shIdKey);
  },

  clearRole: () => {
    localStorage.removeItem(roleKey);  
  },

  clearSession: () => {
    localStorage.removeItem(navigateToKey);    
    localStorage.removeItem(fiscalYearKey);    
    localStorage.removeItem(shIdKey);
    localStorage.removeItem(roleKey);     
  },

} 

export default SessionService;